import { type RootContainerProps } from "@client/content/types";
import { connectCustom } from "@client/lib/misc";
import { getSettingValueSelector, TargetSelector } from "@client/selectors";
import { type AppState } from "@client/types";
import { localStateSelector } from "../selectors";
import Component, { type MapProps } from "./component";

const makeMapStateToProps = () => {
  const purchasedSelector = getSettingValueSelector(TargetSelector.Entity, "purchased");

  return (state: AppState, props: RootContainerProps): MapProps => {
    const localState = localStateSelector(state, props);
    const purchased = purchasedSelector(state, props);

    return {
      ...props,
      hasCourses: localState.availableCourses.length > 0,
      showPurchased: purchased === "all" || purchased === "purchased",
      showUnpurchased: purchased === "all" || purchased === "unpurchased"
    };
  };
};
export default connectCustom(makeMapStateToProps)(Component);
